<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <img width="70%" src="../../../assets/images/logo/logo.png" alt="" />
      </b-link>
      <b-col lg="12" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="4" class="px-xl-2 mx-auto">
          <b-card-title
              style="text-align: center"
              class="mb-4 font-weight-bold"
              title-tag="h2"
          >
            Welcome
          </b-card-title>
          <b-card-text style="text-align: center" class="mb-2">
            <!-- Please sign-in to your account. -->
          </b-card-text>
          <validation-observer ref="loginForm" #default="{ invalid }">
            <b-form class="auth-login-form mt-2" @submit.prevent="login">
              <!-- email -->
              <b-form-group label="Username" label-for="login-email">
                <validation-provider
                    #default="{ errors }"
                    name="Email"
                    vid="email"
                    rules="required"
                >
                  <b-form-input
                      id="login-email"
                      v-model="userEmail"
                      :state="errors.length > 0 ? false : null"
                      name="login-email"
                      placeholder="john@example.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group label-for="login-password" label="Password">
                <validation-provider
                    #default="{ errors }"
                    name="Password"
                    vid="password"
                    rules="required"
                >
                  <b-input-group
                      class="input-group-merge"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                        id="login-password"
                        v-model="password"
                        :state="errors.length > 0 ? false : null"
                        class="form-control-merge"
                        :type="passwordFieldType"
                        name="login-password"
                        placeholder="Password"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                          class="cursor-pointer"
                          :icon="passwordToggleIcon"
                          @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group label="Captcha" label-for="login-captcha">
                  <validation-provider
                      #default="{ errors }"
                      name="Captcha"
                      vid="captcha"
                      rules="required"

                  >
                    <div class="d-flex align-items-center">
                      <b-form-input
                          id="login-captcha"
                          v-model="captcha"
                          :state="errors.length > 0 ? false : null"
                          name="login-captcha"
                          placeholder="Enter the CAPTCHA code."
                      />
                      <img
                          :src="captchaImg"
                          alt="captcha"
                          class="ml-1"
                          @click="getCaptchaInfo"
                      />
                      <div>
                        <img
                            :src="require(&quot;@/assets/images/verify/refresh_small.png&quot;)"
                            alt="refresh captcha"
                            class="refresh-img"
                            :class="{ rotating: isRotating }"
                            height="30"
                            @click="getCaptchaInfo"
                        />
                      </div>
                    </div>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
              </b-form-group>
              <el-button
                  :loading="loginLoading"
                  type="primary"
                  block
                  style="width: 100%"
                  :disabled="invalid"
                  @click="handleLogin"
              >
                Sign in
              </el-button>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BAlert,
  VBTooltip,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import {login, getSelfProfile, getCaptchaInfo} from '@/api/login'
import { setToken } from '@/utils/auth'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {Message} from 'element-ui'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BAlert,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
    ToastificationContent,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      loginLoading: false,
      status: '',
      password: '',
      userEmail: '',
      captcha: '',
      captchaKey: '',
      captchaImg: '',
      isRotating: false,
      sideImg: require('@/assets/images/pages/login-v2.svg'),

      // validation rules
      required,
      email,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    getCaptchaInfo() {
      this.isRotating = true
      getCaptchaInfo().then((res) => {
        this.captchaKey = res.captcha.key
        this.captchaImg = res.captcha.img
      }).catch(() => {
        Message.error('Can not request Captcha Image. Please check you network.')
      })
      // 动画结束后移除旋转类（假设动画 500ms）
      setTimeout(() => {
        this.isRotating = false
      }, 500)
    },
    handleLogin() {
      this.loginLoading = true

      if (!this.userEmail || !this.password) {
        return
      }
      const data = {
        username: this.userEmail,
        password: this.password,
        captcha: this.captcha,
        captcha_key: this.captchaKey,
      }
      login(data)
        .then((res) => {
          if (res.result === 'success' && res.data.role === 1) {
            const token = res.data.access_token
            setToken(token)
            sessionStorage.setItem('isLogin', 'yes')
            this.getProfle()
          }
        })
        .catch((err) => {
          this.loginLoading = false
          // 登录完成后清空密码输入框
          this.password = ''
          this.captcha = ''
          this.getCaptchaInfo()
        })
        .finally(() => {
          this.loginLoading = false
        })
    },
    getProfle() {
      getSelfProfile().then((res) => {
        const userData = {
          fullName: res.data.user_name,
          role: res.data.role,
          name: res.data.name,
          // 到期日交由登入後的常駐橫幅提醒（AccountExpiryBanner）顯示
          expireDate: res.data.expire_date,
        }
        localStorage.setItem('userData', JSON.stringify(userData))
        this.loginLoading = false
        this.$router.push('/dashboard/management-center')
      })
    },
  },
  created() {
    localStorage.clear()
    sessionStorage.clear()
    // 清除cookie
    const cookies = document.cookie.split(';')
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i]
      const eqPos = cookie.indexOf('=')
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
      document.cookie = `${name  }=;expires=Thu, 01 Jan 1970 00:00:00 GMT`
    }
    this.getCaptchaInfo()
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";

.refresh-img {
  margin-left: 8px;
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  outline: none;
}

/* 定义顺时针旋转动画 */
@keyframes rotateClockwise {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg); /* 顺时针一圈 */
  }
}

.rotating {
  animation: rotateClockwise 0.5s linear forwards;
}
</style>